import React, { createContext, useContext, useState } from "react";

const AdminModeContext = createContext(null);

const STORAGE_KEY = "adminPanelMode";

export const AdminModeProvider = ({ children }) => {
  const [mode, setModeState] = useState(
    () => localStorage.getItem(STORAGE_KEY) || "retail",
  );

  const setMode = (next) => {
    localStorage.setItem(STORAGE_KEY, next);
    setModeState(next);
  };

  return (
    <AdminModeContext.Provider value={{ mode, setMode }}>
      {children}
    </AdminModeContext.Provider>
  );
};

export const useAdminMode = () => {
  const ctx = useContext(AdminModeContext);
  if (!ctx) throw new Error("useAdminMode must be used inside AdminModeProvider");
  return ctx;
};
